import Logger from 'logger';
import { ApiResponse } from '../features/lead-list-research/webmetics/webmetics.types';
import { API_V1 } from './APIs/APIv1';
import _ from 'lodash';

export interface LimitWeights {
  messages?: number;
  visits?: number;
  connections?: number;
  emails?: number;
  coldCalls?: number;
  inMails?: number;
}

export interface FunnelBasic {
  _id: string;
  name: string;
  limitWeights: LimitWeights;
}

export const getFunnelsOfLinkedinAccount = async (accountId: string, funnelId?: string): Promise<ApiResponse<FunnelBasic[]>> => {
  return API_V1.get(`/linkedin-accounts/${accountId}/linked-campaigns`, {
    params: { funnelId },
  });
};

export const updateLinkedinFunnelLimitWeights = async (
  funnelId: string,
  payload: { limitWeights: LimitWeights }
): Promise<ApiResponse<unknown>> => {
  return API_V1.patch(`/campaigns/${funnelId}`, payload);
};

export const updateLinkedinFunnelLimitWeightsAlt = async (funnelId: string, payload: { limitWeights: LimitWeights }) => {
  try {
    const response = await API_V1.patch(`/campaigns/${funnelId}`, payload);

    return response.data;
  } catch (e) {
    Logger.trace('Error while updating the linkedin funnel %s limit weights!', funnelId);
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

// Export with old name for compatibility (will be updated)
export const patchLinkedinFunnelLimitWeights = updateLinkedinFunnelLimitWeights;
